import React from "react";
import station1Image from "../assets/images/station/station1.png";
import station2Image from "../assets/images/station/station2.png";
import station3Image from "../assets/images/station/station3.png";

const stationSections = [
  {
    title: "Station ID",
    fields: [
      { label: "Station ID", valueKey: "stationID" },
      { label: "Time Zone", valueKey: "tz" },
    ],
  },
  {
    title: "Observation Time",
    fields: [
      { label: "UTC", valueKey: "obsTimeUtc" },
      { label: "Local", valueKey: "obsTimeLocal" },
    ],
  },
  {
    title: "Geographic Coordinates",
    fields: [
      { label: "Latitude", valueKey: "lat" },
      { label: "Longitude", valueKey: "lon" },
    ],
  },
];

const stationImages = [
  { src: station1Image, alt: "Weather station wide view", className: "station-image-tile" },
  {
    src: station2Image,
    alt: "Weather station mounted equipment",
    className: "station-image-tile station-image-secondary",
  },
  {
    src: station3Image,
    alt: "Weather station sensor close-up",
    className: "station-image-tile station-image-secondary",
  },
];

const StationInfoPage = ({ stationInfo, statusMessage }) => (
  <div className="page-content">
    <h1>Station Information</h1>

    {statusMessage ? <div className="status-banner">{statusMessage}</div> : null}

    <div className="weather-container">
      {stationSections.map((section) => (
        <div className="weather-group" key={section.title}>
          <div className="weather-header">
            <h4>{section.title}</h4>
          </div>
          <div className="weather-body">
            {section.fields.map((field) => (
              <p key={field.label}>
                {field.label}: {stationInfo?.[field.valueKey] ?? "N/A"}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>

    <div className="station-image-grid">
      {stationImages.map((image) => (
        <img key={image.alt} src={image.src} alt={image.alt} className={image.className} />
      ))}
    </div>
  </div>
);

export default StationInfoPage;
